import React from 'react';
import { Provider } from 'react-redux';
import { RouterContext } from 'react-router';

export default class ViasportApp extends React.PureComponent {
  static propTypes = {
    renderProps: React.PropTypes.object,
    app: React.PropTypes.shape({
      store: React.PropTypes.object,
      adIdGenerator: React.PropTypes.object,
      t: React.PropTypes.func,
      serverTime: React.PropTypes.func,
    }),
  };

  static childContextTypes = {
    app: React.PropTypes.shape({
      adIdGenerator: React.PropTypes.object,
      t: React.PropTypes.func,
      serverTime: React.PropTypes.func,
    }),
  };

  getChildContext() {
    return {
      app: {
        adIdGenerator: this.props.app.adIdGenerator,
        t: this.props.app.t,
        serverTime: this.props.app.serverTime,
      },
    };
  }

  render() {
    return (
      <Provider store={this.props.app.store}>
        <RouterContext {...this.props.renderProps} />
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Page/ViasportApp.jsx